import logo from "../assets/SK.svg"
import homeIcon from "../assets/homeIcon.svg"
import profileIcon from "../assets/profileIcon.svg"
import rocketIcon from "../assets/rocketIcon.svg"
import skillIcon from "../assets/skillIcon.svg"
import contactIcon from "../assets/contactIcon.svg"
import retweetIcon from "../assets/retweetIcon.svg"
import commentIcon from "../assets/commentIcon.svg"
import heartIcon from "../assets/heartIcon.svg"
import shareIcon from "../assets/shareIcon.svg"
import resumeIcon from "../assets/resumeIcon.svg"
import emailIcon from "../assets/emailIcon.svg"
import phoneIcon from "../assets/phoneIcon.svg"
import locationIcon from "../assets/locationIcon.svg"
import analyticsIcon from "../assets/analyticsIcon.svg"
import githubIcon from "../assets/githubIcon.svg"
import resumePdf from "../assets/Saurabh_Kumar_Resume.pdf"
import downloadIcon from "../assets/downloadIcon.svg"
import viewIcon from "../assets/viewIcon.svg"
import bannerImage from "../assets/bannerImg.png"
import profilePic from "../assets/profilePic.jpeg"

//Icons
export const LOGO = logo
export const HOME_ICON = homeIcon
export const PROFILE_ICON = profileIcon
export const SKILL_ICON = skillIcon
export const PROJECT_ICON = rocketIcon
export const CONTACT_ICON = contactIcon
export const RETWEET_ICON = retweetIcon
export const HEART_ICON = heartIcon
export const SHARE_ICON = shareIcon
export const COMMENT_ICON = commentIcon
export const RESUME_ICON = resumeIcon
export const VIDEO_ICON="https://cdn-icons-png.flaticon.com/512/2504/2504965.png"
export const VIEW_ICON="https://cdn-icons-png.flaticon.com/512/2235/2235419.png"
export const GITHUB_ICON="https://cdn-icons-png.flaticon.com/128/2504/2504911.png"
export const PHONE_ICON = phoneIcon
export const PHONE_COLOR_ICON = "https://cdn-icons-png.flaticon.com/512/724/724664.png"
export const LOCATION_ICON = locationIcon
export const LINKEDIN_COLOR_ICON ="https://cdn-icons-png.flaticon.com/512/145/145807.png"
export const GITHUB_COLOR_ICON =githubIcon
export const EMAIL_COLOR_ICON ="https://cdn-icons-png.flaticon.com/512/9068/9068642.png"
export const EMAIL_ICON = emailIcon
export const ANALYTICS_ICON=analyticsIcon
export const DOWNLOAD_ICON=downloadIcon
export const VIEW_ICON_SVG =viewIcon
export const WEB_ICON ="https://cdn-icons-png.flaticon.com/512/3059/3059997.png"



//NavBarTabs

export const HOME_TAB="Home"
export const ABOUT_ME_TAB="About Me"
export const SKILLS_TAB="Skills"
export const PROJECTS_TAB="Projects"
export const CONTACT_TAB="Contact"
export const RESUME_TAB="Resume"

//NavTabsIDs

export const HOME_TAB_ID="home"
export const ABOUT_ME_TAB_ID="aboutme"
export const SKILLS_TAB_ID="skills"
export const PROJECTS_TAB_ID="projects"
export const CONTACT_TAB_ID="contact"
export const RESUME_TAB_ID="resume"




//SkillIcons
export const REACT_ICON="https://cdn-icons-png.flaticon.com/512/1126/1126012.png"
export const MONGO_ICON="https://cdn.iconscout.com/icon/free/png-256/mongodb-4-1175139.png"
export const EXPRESS_ICON="https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg"
export const NODE_ICON="https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg"
export const REDUX_ICON="https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg"
export const HTML_ICON="https://cdn-icons-png.flaticon.com/512/174/174854.png"
export const CSS_ICON="https://cdn-icons-png.flaticon.com/512/732/732190.png"
export const JAVASCRIPT_ICON="https://cdn-icons-png.flaticon.com/512/5968/5968292.png"
export const JAVA_ICON="https://images.freeimages.com/fic/images/icons/2796/metro_uinvert_dock/256/java.png"
export const FIREBASE_ICON="https://avatars.githubusercontent.com/u/1335026?s=200&v=4"
export const TYPESCRIPT_ICON="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/1200px-Typescript_logo_2020.svg.png"
export const CHAKRA_UI_ICON="https://avatars.githubusercontent.com/u/54212428?s=200&v=4"
export const KOTLIN_ICON="https://developer.android.com/static/images/cluster-illustrations/kotlin-hero.svg"
export const PHP_ICON="https://www.php.net/images/logos/php-logo.svg"
export const MYSQL_ICON="https://www.mysql.com/common/logos/logo-mysql-170x115.png"
export const GIT_ICON="https://avatars.githubusercontent.com/u/18133?s=200&v=4"
export const VERCEL_ICON="https://camo.githubusercontent.com/add2c9721e333f0043ac938f3dadbc26a282776e01b95b308fcaba5afaf74ae3/68747470733a2f2f6173736574732e76657263656c2e636f6d2f696d6167652f75706c6f61642f76313538383830353835382f7265706f7369746f726965732f76657263656c2f6c6f676f2e706e67"
export const NETLIFY_ICON="https://avatars.githubusercontent.com/u/7892489?s=200&v=4"
export const RENDER_ICON="https://avatars.githubusercontent.com/u/36424661?s=200&v=4"

//FramewrokIcons
export const ANDROID_STUDIO_ICON="https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Android_Studio_Icon_3.6.svg/768px-Android_Studio_Icon_3.6.svg.png"
export const VSCODE_ICON="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/768px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519"
export const SUBLIME_ICON="https://www.sublimehq.com/images/sublime_text.png"
export const CODE_SAND_ICON="https://avatars.githubusercontent.com/u/32880324?s=200&v=4"
export const CODE_PEN="https://avatars.githubusercontent.com/u/1545643?s=200&v=4"
export const REPLIT_ICON="https://avatars.githubusercontent.com/u/983194?s=200&v=4"




//MyProfileInfo
export const MY_PIC =profilePic
// export const MY_PIC = "https://drive.google.com/uc?export=view&id=15JVBxfQW7o46ebmDLsyp-CPEjMOOsEaZ"
// export const MY_BANNER_PIC ="https://github.com/dev-Imsaurabh/image-hosting-repo/blob/master/banner/banner1.png?raw=true"
export const MY_BANNER_PIC =bannerImage
export const MY_NAME="Saurabh Kumar"
export const MY_POSITION = "Senior Software Engineer"
export const MY_POSITION_ID = "@Senior_Software_Engineer"
export const MY_USERNAME= "dev.imsaurabh"


export const ABOUT_ME=`Senior Software Engineer with 3+ years of experience building AI-powered web applications, interactive visual editors, and scalable frontend systems. I specialize in React, TypeScript, canvas technologies, backend integrations, cloud delivery, and performance optimization. As a founding engineer at Personate.ai, I have delivered production-ready features for AI video workflows used by 150+ global brands and agencies.`

export const MY_RESUME=""
export const MY_RESUME_PDF=resumePdf
export const MY_RESUME_PDF_FILE_NAME="Saurabh_Kumar_Resume.pdf"
export const MY_COUNTRY_CODE="+91"
export const MY_PHONENUMBER="6393567935"
export const MY_EMAIL="sau4478@gmail.com"
export const LINKEDIN= "https://www.linkedin.com/in/dev-saurabh-kumar/"
export const MY_LOCATION="Varanasi, Uttar Pradesh"
export const SKILL_CAPTION="I build responsive, high-performance product experiences across AI, video, and interactive canvas workflows - from reusable React architecture to cloud-backed media delivery."
export const SKILL_CAPTION_HASHTAG="#React #TypeScript #AI #Canvas #Performance"
export const STATS_CAPTION="Impact delivered through production AI tooling, scalable frontend architecture, and hands-on collaboration with product teams."
export const BOTTOM_LINE="Open to senior software engineering opportunities. Let's build thoughtful, high-impact products."
export const CONTACT_HEADLINE="Connect With Me"
export const CONTACT_SUBLINE="Let's talk about your next product challenge."





//Github
export const GITHUB_USERNAME="dev-Imsaurabh" //change only GitHub username to use my portfolio
export const GITHUB_PROFILE_LINK=`https://github.com/${GITHUB_USERNAME}`
export const GITHUB_FOLLOWERS_URL= `https://api.github.com/users/${GITHUB_USERNAME}/followers`
export const GITHUB_FOLLOWING_URL= `https://api.github.com/users/${GITHUB_USERNAME}/followers`
export const GITHUB_REPO_COUNT =`https://api.github.com/users/${GITHUB_USERNAME}/repos?per_page=100`
export const GITHUB_STATS_1 = `https://github-stats-alpha.vercel.app/api?username=${GITHUB_USERNAME}&cc=2e3440&tc=fff&ic=fff&bc=gray
`
export const GITHUB_STATS_2 = `https://streak-stats.demolab.com/?user=dev-Imsaurabh&theme=react&background=2e3440`
export const GITHUB_STATS_3 = `https://github-profile-summary-cards.vercel.app/api/cards/most-commit-language?username=${GITHUB_USERNAME}&theme=nord_dark`

export const GITHUB_STATS_4 = `http://github-profile-summary-cards.vercel.app/api/cards/profile-details?username=${GITHUB_USERNAME}&theme=nord_dark`
export const GITHUB_STATS_5 = `http://github-profile-summary-cards.vercel.app/api/cards/repos-per-language?username=${GITHUB_USERNAME}&theme=nord_dark`



//Contact Me Config
export const FORMSPREE_ID="mwkjkokr"
export const  FORMSPREE_API=`https://formspree.io/f/${FORMSPREE_ID}`


